export default __webpack_public_path__ + "static/media/aicorelogo.5ea687e6.png";